module.exports = __webpack_public_path__ + "static/media/instagram_logo.407e6028.png";